import gql from 'graphql-tag';

export const ENTITY_RATE_LIMITS_FRAGMENT = gql`
  fragment EntityRateLimits on Entity {
    rateLimits {
      graphql
      sdkGraphql
      filestreamCount
      filestreamPerRunCount
      filestreamSize
      runUpdateCount
      sdkGraphqlQuerySeconds
      createArtifacts
      createArtifactsRequestCount
      createArtifactsTimeWindow
    }
  }
`;

const PROJECT_RATE_LIMITS_FRAGMENT = gql`
  fragment ProjectRateLimits on Project {
    rateLimits {
      filestreamCount
      filestreamPerRunCount
      filestreamSize
      runUpdateCount
      sdkGraphqlQuerySeconds
      createArtifacts
      createArtifactsRequestCount
      createArtifactsTimeWindow
    }
  }
`;

export const SUBSCRIPTION_UPDATE = gql`
  mutation updateSubscription(
    $entityName: String!
    $teamsEnabled: Boolean
    $privateProjects: Boolean
    $gpuEnabled: DateTime
    $hubPreset: String
    $repo: String
    $disk: String
    $redisEnabled: Boolean
    $dockerEnabled: Boolean
    $image: String
  ) {
    updateSubscription(
      input: {
        entityName: $entityName
        teamsEnabled: $teamsEnabled
        privateProjects: $privateProjects
        gpuEnabled: $gpuEnabled
        hubPreset: $hubPreset
        hubSettings: {
          repo: $repo
          disk: $disk
          redisEnabled: $redisEnabled
          dockerEnabled: $dockerEnabled
          image: $image
        }
      }
    ) {
      entity {
        id
        name
        available
        photoUrl
        limits
      }
    }
  }
`;

export const TEAM_PHOTO_UPDATE = gql`
  mutation updateEntityPhoto($entityName: String!, $photoUrl: String) {
    updateEntity(input: {entity: $entityName, photoUrl: $photoUrl}) {
      entity {
        id
        name
        available
        photoUrl
        limits
      }
    }
  }
`;

/** Just make sure the entity projection on
 * TEAM_QUERY, TEAM_PHOTO_UPDATE, SUBSCRIPTION_UPDATE
 * is the same to avoid issues with apollo caching there is
 * some issue with how apollo caching gets effected if the porjection
 * is differrent
 */

export const TEAM_QUERY = gql`
  query TeamQuery($name: String) {
    entity(name: $name) {
      id
      name
      available
      photoUrl
      limits
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
  }
`;

export const USER_QUERY = gql`
  query UserQuery($userName: String!) {
    user(userName: $userName) {
      id
    }
  }
`;

export const ALL_ENTITIES = gql`
  query allEntities($first: Int = 2000) {
    entities(first: $first) {
      edges {
        node {
          id
          createdAt
          name
          memberCount
          isTeam
          members {
            admin
            pending
            username
            email
            name
            id
          }
        }
      }
    }
  }
`;

export const UPDATE_ENTITY_ADMIN = gql`
  mutation UpdateEntityAdmin(
    $entityName: String!
    $isPaid: Boolean
    $rateLimits: RateLimitsInput
  ) {
    updateEntity(
      input: {entity: $entityName, isPaid: $isPaid, rateLimits: $rateLimits}
    ) {
      entity {
        id
        isPaid
        ...EntityRateLimits
      }
    }
  }
  ${ENTITY_RATE_LIMITS_FRAGMENT}
`;

// id consists of project name and entity name
export const UPDATE_PROJECT_ADMIN = gql`
  mutation UpdateProjectAdmin($id: String!, $rateLimits: RateLimitsInput) {
    upsertModel(input: {id: $id, rateLimits: $rateLimits}) {
      project {
        id
        ...ProjectRateLimits
      }
    }
  }
  ${PROJECT_RATE_LIMITS_FRAGMENT}
`;

export const PROJECT_RATE_LIMITS = gql`
  query ProjectRateLimits($projectName: String!, $entityName: String) {
    project(name: $projectName, entityName: $entityName) {
      id
      ...ProjectRateLimits
    }
  }
  ${PROJECT_RATE_LIMITS_FRAGMENT}
`;

export const TRIGGER_PARQUET_EXPORT = gql`
  mutation triggerParquetExport($runId: ID!) {
    triggerParquetExport(input: {runId: $runId}) {
      task {
        id
      }
    }
  }
`;

export const TRIGGER_RECOMPUTE_KEYS_INFO = gql`
  mutation triggerRecomputeKeysInfo($runId: ID!) {
    triggerRecomputeKeysInfo(input: {runId: $runId}) {
      task {
        id
      }
    }
  }
`;

export const TRIGGER_EVENTS_EXPORT = gql`
  mutation triggerEventsExport($runId: ID!) {
    triggerEventsExport(input: {runId: $runId}) {
      task {
        id
      }
    }
  }
`;

export const TRIGGER_FLAT_RUNS_MIGRATOR = gql`
  mutation triggerFlatRunsMigrator(
    $entityName: String
    $organizationName: String
  ) {
    triggerFlatRunsMigrator(
      input: {entityName: $entityName, organizationName: $organizationName}
    ) {
      glueTaskName
    }
  }
`;
